<template>
  <div>
    <div :class="cardClass">
      <div class="reserve-card-title">
        <h3>RESERVE</h3>
        <span class="card-id-lable"
          >id:
          <h3 class="card-id">
            {{ reservation.local_id ? reservation.local_id : "ABCD  " }}
          </h3></span
        >
      </div>

      <ClientName :clientName="reservation.name" />
      
      <div class="cheque-list-details">
         
          <div class="cheque-detail-item">
            <img
              :src="
                showWhiteIcons ? '/icons/mobile-white.svg' : '/icons/mobile.svg'
              "
            />
            <!-- <p class="order-info">{{ $t('reserve.card_phone') }}</p> -->

            <a class="phone-link" :href="`tel:${reservation.phone}`">
              <p>{{ reservation.phone }}</p>
            </a>
          </div>
          <div class="cheque-detail-item">
            <img
              :src="
                showWhiteIcons ? '/icons/time-white.svg' : '/icons/time.svg'
              "
            />
            <!-- <p class="order-info">{{ $t('reserve.card_reserve_time') }}</p> -->
            <p>
              {{ reservation.reserve_date | formatReservationTime }}
            </p>
          </div>
          <div class="cheque-detail-item">
            <img
              :src="
                showWhiteIcons ? '/icons/date-white.svg' : '/icons/date.svg'
              "
            />
            <!-- <p class="order-info">{{ $t('reserve.card_reserve_date') }}</p> -->
            <p>
              {{ reservation.reserve_date | formatReservationDate }}
            </p>
          </div>
          <div class="cheque-detail-item">
            <img
              :src="
                showWhiteIcons
                  ? '/icons/cutlery-dark.svg'
                  : '/icons/cutlery.svg'
              "
            />

            <p>
              {{ reservation.guests_count }}
              {{ $tc("reserve.card_guests_count", reservation.guests_count) }}
            </p>
          </div>
         
      </div>
      <ReserveStatusBar
        v-if="reservation.status == 'confirmed'"
        :reserve="reservation"
      />
      <div :class="['comment', commentColorClass]" v-if="reservation.comment">
        <h6 class="color-grey">{{ $t("card.comment") }}</h6>
        <p>
          {{ reservation.comment }}
        </p>
      </div>
      <div v-if="reservation.status == 'accepted'" class="accepted-reserve">
        {{ $t("reserve.card_accepted") }}
        <hr />
        <div class="delete-container">
          <QueueButton
            class="w-100"
            variant="cancel-outline"
            @click="showCancelUI"
          >
            {{$t('reserve.card_cancel')}}
          </QueueButton>
        </div>
      </div>
      <!-- <OrderStatus v-if="reservation.status !== 'confirmed'"/> -->
      <small v-if="reservation.status == 'confirmed'">{{
        $t("preorder_card.wait_limit")
      }}</small>
      <div class="notif-actions" v-if="reservation.status === 'confirmed'">
        <button class="remove" @click="showCancelUI" :disabled="busy">
          <img src="/icons/trash-white.svg" alt />
        </button>
        <button class="accept" @click="onAccept" :disabled="busy">
          {{ $t("reserve.card_accept") }}
        </button>
      </div>
    </div>

    <RefuseModal
      @cancel="cancel_modal = false"
      @confirm="onCancel"
      v-if="cancel_modal"
    />
  </div>
</template>

<script>
import moment from "moment";

import RefuseModal from "@/components/modals/RefuseModal.vue";
import ReserveStatusBar from "@/components/statusbar/ReserveStatusBar.vue";
// import OrderStatus from '@/components/OrderStatus.vue'
import ClientName from "@/components/ClientName.vue";
import QueueButton from "@/components/QueueButton.vue";

export default {
  props: {
    reservation: Object,
  },
  data() {
    return {
      cancel_modal: false,
      busy: false,
    };
  },
  methods: {
    onAccept() {
      this.busy = true;
      this.$store
        .dispatch("reserve/acceptReservation", this.reservation)
        .finally(() => {
          this.busy = false;
        });
    },
    onCancel(reason) {
      this.busy = true;
      this.$store
        .dispatch("reserve/cancelReservation", {
          reservation: this.reservation,
          reason,
        })
        .finally(() => {
          this.busy = false;
        });
      this.cancel_modal = false;
    },
    showCancelUI() {
      this.cancel_modal = true;
    },
  },
  computed: {
    commentColorClass() {
      return this.reservation.status == "confirmed"
        ? "comment-white"
        : "comment-black";
    },
    cardClass() {
      return {
        "notif-card": true,
        reserve: true,
        [`reserve-card-${this.reservation.status}`]: true,
        "reserve-creating": !this.reservation.local_id,
      };
    },
    showWhiteIcons() {
      return this.reservation.status == "cancelled";
    },
  },
  filters: {
    formatReservationTime(raw) {
      return moment(raw).format("HH:mm");
    },
    formatReservationDate(raw) {
      return moment(raw).format("DD.MM.YYYY");
    },
  },
  components: {
    RefuseModal,
    ReserveStatusBar,
    ClientName,
    QueueButton,
    // OrderStatus
  },
};
</script>

<style scoped>
.reserve-card-title h3 {
  margin: 0;
}

.card-id-lable {
  font-size: 4vw;
  color: #212529;
}
h3.card-id {
  padding: 0;
  display: inline;
}
.reserve-card-title {
  display: flex;
  justify-content: space-between;
  padding: 2.5vh 5.4vw 1.9vh;
}
button.remove {
  border-radius: 5vh;

  background: #e2223b;
  border: none;
  outline: none;
  box-shadow: 0px 4px 1px rgba(0, 0, 0, 0.25);
}

button.remove img {
  height: 2.6vh;
  width: auto;
  margin: 0 auto;
  display: block;
}

button.accept {
  padding: 1.6vh;
  border-radius: 5vh;
  background: #129b81;
  border: none;
  font-size: 2vh;
  width: 100%;
  margin-left: 2vh;
  color: #ededed;
  outline: none;
  box-shadow: 0px 4px 1px rgba(0, 0, 0, 0.25);
}

small {
  text-align: center;
  color: #908f8d;
  display: block;
  background: #ededed;
  padding-top: 3.69vh;
}

.accepted-reserve {
  text-align: center;
  font-size: 1.8vh;
  padding: 3.7vh 0;
  background: #1d1d1d;
  color: #ededed;
  border-radius: 0 0 2.7vh 2.7vh;
  border-top: 1px solid #908f8d;
  padding-bottom: 2.5vh;
}

.delete-container {
  padding: 0 2.5vh;
}

button.remove {
  border-radius: 5vh;
  padding: 0 1.8vh;
  background: #e2223b;
  border: none;
  outline: none;
}

button.remove img {
  height: 2.6vh;
  width: auto;
}

button.accept {
  padding: 1.6vh;
  border-radius: 5vh;
  width: 100%;
  background: #129b81;
  border: none;
  font-size: 2vh;
  color: #ededed;
  outline: none;
}

.notif-actions {
  background: #ededed;
  display: flex;
  border-radius: 0 0 2.7vh 2.7vh;
  padding: 2.5vh 2.5vh 3.7vh;
  justify-content: space-between;
}

.notif-card {
  width: 90%;
  position: relative;
  margin: 0 auto 2.5vh;
  background: #ffffff;
  display: block;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 1.7vh;
  padding: 2.5vh;
}

.reserve {
  background: #aeccc6;
  padding: 0;
  border-radius: 1.7vh 1.7vh 3.5vh 3.5vh;
}

.reserve h4 {
  font-size: 3.7vh;
  font-weight: 500;
  padding: 2.5vh;
}

h4 {
  font-size: 2.3vh;
  font-weight: 600;
  margin: 0;
  line-height: 1;
}
span {
  font-size: 2vh;
  line-height: 1;
  align-self: center;
  color: #a4a3a1;
}
p.content {
  font-size: 2vh;
  margin: 0;
  line-height: normal;
  padding-top: 1.1vh;
  color: #454543;
}

p.order-info {
  line-height: normal;
  margin-bottom: 0;
  font-size: 2vh;
  padding-left: 1vh;
  display: inline-block;
}

.reserve-card-confirmed {
  background: #aeccc6;
  border-radius: 2.5vh 2.5vh 2.7vh 2.7vh;
}

.reserve-card-accepted {
  /* background: #129B81; */
  /* border-radius: 2.5vh 2.5vh 2.7vh 2.7vh; */
  border-radius: 2.5vh 2.5vh 2.7vh 2.7vh;
  /* color: #ededed; */
}

.reserve-card-cancelled {
  background: #e2223b;
  border-radius: 2.5vh 2.5vh 1.7vh 1.7vh;
  color: #ededed;
}

.phone-link {
  margin-left: auto;
  color: inherit;
}
p.float-right {
  margin-bottom: 0;
}
.comment {
  padding: 2.5vh 5.4vw 2.5vh;
}

.comment h6 {
  font-weight: 500;
  font-size: 5vw;
  margin-bottom: 0;
  color: #a4a3a1;
}

.comment p {
  padding: 1.3vh 4vw 0;
  margin-bottom: 0;
  font-size: 1.6vh;
  line-height: 1.8vh;
}
.comment-white {
  background: #ededed;
}
.comment-black {
  background: #1d1d1b;
}
.comment-black p {
  color: #ededed;
}

.reserve-creating {
  border-radius: 1.7vh;
}

hr {
  border-top: 1px solid #908f8d;
  outline: none;
  margin-bottom: 2.5vh;
}

@media screen and (min-width: 768px) {
  .comment {
    padding: 1.389vw 1.389vw 1.389vw 1.389vw;
    margin: 0;
  }
  .comment h6 {
    font-size: 1.25vw;
    line-height: 1.458vw;
  }
  .comment p {
    padding: 0.694vw 0.694vw 0;
    font-size: 0.903vw;
    line-height: 1.042vw;
  }
  small {
    padding-top: 2.083vw;
  }
  .notif-card {
    width: 23.264vw;
    margin-bottom: 1.389vw;
  }
  .reserve-card-title {
    font-size: 2.083vw;
    line-height: 2.431vw;
    padding: 1.736vw 1.389vw 1.389vw;
  }
  .reserve-card-title h3 {
    padding: 0;
    font-size: 2.083vw;
    line-height: 2.431vw;
  }
  .card-id-container {
    padding: 0;
  }
  .card-id-lable h3.card-id {
    padding: 0;
    font-size: 2.083vw;
    line-height: 2.083vw;
  }
  .card-id-lable {
    padding: 0;
    font-size: 1.042vw;
    line-height: 1.4vw;
    color: #212529;
  }

  .order-details {
    padding: 1.389vw;
  }
  div.d-flex.w-100 {
    padding-top: 1.389vw;
  }
  div.d-flex.w-100:first-child {
    padding-top: 0;
  }
  div.d-flex.w-100 img {
    width: 1.25vw;
    height: 1.25vw;
  }
  div.d-flex.w-100 p {
    font-size: 1.111vw;
    line-height: 1.25vw;
  }
  .accepted-reserve {
    padding: 2.083vw 1.389vw;
    font-size: 0.903vw;
    line-height: 1.042vw;
    color: #908f8d;
  }
  .notif-actions {
    padding: 1.389vw 1.389vw 2.083vw;
  }
  button.accept {
    width: 15.625vw;
    height: 3.403vw;
    font-size: 1.111vw;
    line-height: 1.25vw;
  }
  button.remove {
    width: 3.403vw;
    height: 3.403vw;
    padding: 0;
  }
  button.remove img {
    width: 1.389vw;
    height: 1.389vw;
  }
}
</style>
